import { ICONES_FACETA } from '@/global/components/EscopoFuncionario/Cascata'
import { FormFieldAutocomplete } from 'global/components/Form'
import { centroCusto as centrosCusto } from 'service/api'
import { useStore } from 'store'
import { type CondicaoUi, contar } from './condicao-ui'

function ParametrosCentroCusto() {
    const empresaId = useStore(state => state.companyId)
    const { data = [] } = centrosCusto.useFetch({ queryParams: { empresaId } })
    const nomePorId = new Map(
        data.map(it => [it.id, `${it.codigo} - ${it.nomeCentroCusto}`]),
    )

    return (
        <FormFieldAutocomplete
            name="parametros.centroCustoIds"
            label="Centros de custo"
            multiple
            required
            options={data.map(it => it.id)}
            getOptionLabel={(id: number) => nomePorId.get(id) ?? ''}
            getOptionKey={(id: number) => String(id)}
            isOptionEqualToValue={(opcao, valor) => opcao === valor}
        />
    )
}

export const centroCusto: CondicaoUi = {
    icone: ICONES_FACETA.centrosCusto,
    parametrosIniciais: { centroCustoIds: [] },
    Parametros: ParametrosCentroCusto,
    resumir: parametros =>
        contar(
            parametros.centroCustoIds,
            'centro de custo',
            'centros de custo',
        ),
}
